import { render } from "./PriceComparison.vue?vue&type=template&id=830899d0&scoped=true"
import script from "./PriceComparison.vue?vue&type=script&lang=js"
export * from "./PriceComparison.vue?vue&type=script&lang=js"

import "./PriceComparison.vue?vue&type=style&index=0&id=830899d0&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830899d0"]])

export default __exports__